export function parseCurrencyDigits(raw: string): string {
  return raw.replace(/\D/g, "").slice(0, 9);
}

export function formatCurrencyDisplay(digits: string): string {
  if (!digits) {
    return "";
  }
  const padded = digits.padStart(3, "0");
  const cents = padded.slice(-2);
  const intPart = padded.slice(0, -2).replace(/^0+(?=\d)/, "");
  return `R$ ${Number(intPart).toLocaleString("pt-BR")},${cents}`;
}

export function parseValueNumber(digits: string): number {
  if (!digits) {
    return 0;
  }
  return Number(digits) / 100;
}

export function sanitizeDigits(value: string): string {
  return value.replace(/\D/g, "");
}

const DIGIT_KEYS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

export function isDigitKey(key: string): boolean {
  return DIGIT_KEYS.includes(key);
}
